module.exports = __webpack_public_path__ + "img/Sasha Shilina.4b37f2ea.jpg";